import { generateTypes } from 'helpers/actions'

// Actions
export function send (data) {
  return {
    types: generateTypes('send_feedback'),
    api: api => api('feedback', { method: 'post', body: data }, false),
    onApiSuccess: (nextAction) => {
      nextAction.notify = { type: 'success', message: 'Your message has been sent to TwoXSea!' }
      return nextAction
    }
  }
}

export const actions = {
  send
}



// WEBPACK FOOTER //
// ./src/store/actions/feedback.js